export default __webpack_public_path__ + "static/media/interierove_barvy.ddad11f0.svg";